export const countries = [
    // https://apps.timwhitlock.info/emoji/tables/iso3166
    { text: '🇷🇺', code: 'RU', value: '7', mask: '+7 (###) ###-##-##', compare: '+7 ' }, // 7 XXX XXX-XX-XX // россия, казахстан
    { text: '🇧🇾', code: 'BY', value: '375', mask: '+375 ## ###-##-##', compare: '+375 ' }, // 375 XX XXX-XX-XX // белоруссия
    // не поддерживается
    // { text: '🇦🇲', code: 'AM', value: '374', mask: '+374 ### ###-##', compare: '+374 ' }, // 374 XXX XXX-XX // армения
    // { text: '🇱🇻', code: 'LV', value: '371', mask: '+371 ### ## ###', compare: '+371 ' }, // 371 XXX XX XXX // латвия
    // { text: '🇱🇹', code: 'LT', value: '370', mask: '+370 ### #####', compare: '+370 ' }, // 370 XXX XXXXX // литва
    // { text: '??', code: '??', value: '?', mask: '', compare: '' } // другое, что попало
]

export const defaultFormat = {
    country: '7',
    mask: '+7 (###) ###-##-##'
}
